export default __webpack_public_path__ + "static/media/Cache.320406c1.svg";